import { FC } from "react";
import { IconPropsType } from ".";

export const Filter: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 0.890014C16 0.398468 15.6075 0 15.1233 0H0.876752C0.696221 0 0.520046 0.0566141 0.372391 0.162041C-0.0236423 0.444819 -0.11886 1.00003 0.159683 1.40209L5.32513 8.85754L5.33964 14.2814C5.34054 14.62 5.43971 14.9508 5.62468 15.2325C6.14461 16.0243 7.19837 16.2383 7.97832 15.7104L9.82324 14.4618C10.3134 14.13 10.6068 13.5705 10.604 12.9724L10.5853 8.89034L15.8373 1.40647C15.9432 1.25565 16 1.07513 16 0.890014ZM8.82931 8.32474L8.85068 12.9807L7.0928 14.1704L7.07706 8.29203L2.56527 1.78003H13.4223L8.82931 8.32474Z"
        fill={props.color}
      />
    </svg>
  );
};
